import { render, staticRenderFns } from "./DashboardShortcutCard.vue?vue&type=template&id=10da2d10&scoped=true&"
import script from "./DashboardShortcutCard.vue?vue&type=script&lang=js&"
export * from "./DashboardShortcutCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardShortcutCard.vue?vue&type=style&index=0&id=10da2d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10da2d10",
  null
  
)

export default component.exports